import { render, staticRenderFns } from "./blog13.vue?vue&type=template&id=908545d6"
import script from "./blog13.vue?vue&type=script&lang=js"
export * from "./blog13.vue?vue&type=script&lang=js"
import style0 from "./blog13.vue?vue&type=style&index=0&id=908545d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports